export default __webpack_public_path__ + "static/media/Corruptor's Tasset.01277727.jpg";